import { render, staticRenderFns } from "./BeiHong.vue?vue&type=template&id=863d92f2&scoped=true"
import script from "./BeiHong.vue?vue&type=script&lang=js"
export * from "./BeiHong.vue?vue&type=script&lang=js"
import style0 from "./BeiHong.vue?vue&type=style&index=0&id=863d92f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863d92f2",
  null
  
)

export default component.exports